import styled from "styled-components";
import { theme } from "config/theme";

export const Line = styled.span`
    width: 100%;
    height: 1px;
    background: ${theme.colors.base[200]};
`;
